export const drawerWidth = 240
export const navItems = ["home", "about", "skills", "projects", "contact"]
export const githubProfile = "https://github.com/Nilkanth-Patadiya"
export const linkedInProfile = "https://www.linkedin.com/in/nilkanthpatadiya/"
export const emailID = "nilkanthpatadiya@gmail.com"
export const myAddress = "Ahmedabad, Gujarat, India"
export const myAddressMapLink =
  "https://www.google.com/maps/search/?api=1&query=Ahmedabad%2C%20Gujarat%2C%20India"
export const myName = "Nilkanth Patadiya"
